import { Button } from '@/components/ui/button';
import { useMasterApprenticesStatStore } from '@/features/teacher-student-stat/store';
import { exportTeacherStudentRepublicToExcel } from '@/features/teacher-student-stat/utils/exportTeacherStudentToExcel';
import { Download } from 'lucide-react';
import { FC } from 'react';
import { MasterApprenticesFilter } from '../../filter';
import { TeacherStudentHeader } from '../../header/Header';
import { TableDistrict } from './table/TableDistrict';

export const TerritoryTeacherStatStudent: FC = () => {
  const { masterApprenticesDistrictResponse } = useMasterApprenticesStatStore();
  const hasRows = (masterApprenticesDistrictResponse?.rows.length ?? 0) > 0;

  const handleExport = async () => {
    if (masterApprenticesDistrictResponse) {
      await exportTeacherStudentRepublicToExcel(
        masterApprenticesDistrictResponse,
        `ustoz-shogird-${masterApprenticesDistrictResponse?.district?.district_name?.toLocaleLowerCase()}`,
      );
    }
  };

  return (
    <div className="flex flex-col gap-4 p-8">
      <TeacherStudentHeader
        title={`${masterApprenticesDistrictResponse?.district?.district_name} bo'yicha ustoz-shogirdlar`}
        mastersTotal={0}
        apprenticesTotal={0}
        isResponsible={false}
        isEmployees
      />
      <div className="flex items-center justify-between">
        <MasterApprenticesFilter />
        {hasRows && (
          <Button
            onClick={handleExport}
            className="flex items-center gap-2 bg-green-600 hover:bg-green-700 text-white"
          >
            <Download className="size-4" />
            Excel
          </Button>
        )}
      </div>
      <TableDistrict onTotalsChange={(total) => console.log(total)} />
    </div>
  );
};
